// src/constants/routes.js

export const ROUTES = {
  HOME: "/",
  BUY: "/buy",
  RENT: "/rent",
  OFF_PLAN: "/off-plan",
  AREAS: "/areas",
  AREA_DETAIL: (slug = ":title") => `/areas/${slug}`,

  SERVICES: "/services",

  PROJECTS: "/projects",
  PROJECT_DETAIL: (id = ":id") => `/projects/${id}`,

  DEVELOPERS: "/developers",
  DEVELOPER_DETAIL: (slug = ":title") => `/developers/${slug}`,

  PROPERTIES: (slug = ":title") => `/properties/${slug}`,
  FEATURED_PROPERTY_DETAIL: (slug = ":slug") => `/featured-properties/${slug}`,

  ABOUT_US: "/about-us",
  CONTACT_US: "/contact-us",
  LIST_PROPERTY: "/list-your-property",

  BLOG_LIST: "/blog",
  BLOG_DETAIL: (slug = ":slug") => `/blog/${slug}`,

  MARKET_REPORT: "/market-reports",
  TESTIMONIALS: "/testimonials",

  // fallback
  NOT_FOUND: "*",
};
